import api from './api';

export const maklumatPelayananService = {
    // PUBLIC
    getPublicMaklumat: async () => {
        try {
            const response = await api.get('/maklumat-pelayanan');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    getPublicMaklumatList: async () => {
        try {
            const response = await api.get('/maklumat-pelayanan/list');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // ADMIN
    getMaklumatList: async (params = {}) => {
        try {
            const response = await api.get('/maklumat-pelayanan-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getMaklumat: async (id) => {
        try {
            const response = await api.get(`/maklumat-pelayanan-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    createMaklumat: async (formData) => {
        try {
            const response = await api.post('/maklumat-pelayanan-admin', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    updateMaklumat: async (id, formData) => {
        try {
            const response = await api.post(`/maklumat-pelayanan-admin/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    deleteMaklumat: async (id) => {
        try {
            const response = await api.delete(`/maklumat-pelayanan-admin/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    updateStatus: async (id, status) => {
        try {
            const response = await api.post(`/maklumat-pelayanan-admin/${id}/status`, { status });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },
};